import { Link } from '@tanstack/react-router';
import { Anchor } from 'lucide-react';
import { motion } from 'motion/react';
import { useTranslation } from 'react-i18next';
import { LanguageToggle } from '../components/shell/LanguageToggle';
import { Button } from '../components/ui/Button';
import { ThemeGrid } from '../theme/ThemeSwitcher';

export function AppearancePage() {
  const { t } = useTranslation();
  return (
    <div className="mx-auto flex max-w-[1600px] flex-col gap-8">
      <header>
        <h1 className="text-3xl font-extrabold text-text">{t('theme.title')}</h1>
        <p className="mt-1 text-md text-muted">{t('theme.subtitle')}</p>
      </header>
      <ThemeGrid />
      <section className="flex items-center gap-4">
        <h2 className="text-lg font-bold text-text">{t('language.label')}</h2>
        <LanguageToggle id="appearance-lang" />
      </section>
    </div>
  );
}

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <div className="grid min-h-[60vh] place-items-center text-center">
      <div className="flex flex-col items-center gap-4">
        <motion.div
          animate={{ rotate: [-8, 8, -8], y: [0, -6, 0] }}
          transition={{ duration: 3.2, repeat: Infinity, ease: 'easeInOut' }}
          className="grid h-20 w-20 place-items-center rounded-full bg-accent/20 text-primary"
        >
          <Anchor size={36} />
        </motion.div>
        <h1 className="text-3xl font-extrabold text-text">{t('notFound.title')}</h1>
        <p className="max-w-sm text-md text-muted">{t('notFound.body')}</p>
        <Link to="/">
          <Button>{t('notFound.home')}</Button>
        </Link>
      </div>
    </div>
  );
}
